import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';

import '../../sass/components/sidebar/SidebarSection.scss';

const mapStoreToProps = (store) => ({
  user: store.data.user,
});

class SidebarSection extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: true,
    };
  }

  renderMenuItem = (item) => {
    if (item.admin && !this.props.user.admin) {
      return null;
    }
    return (
      <div
        key={item.page}
        className='menuItem'
        onClick={() => {
          if (this.props.onSelect) {
            this.props.onSelect(item.page);
          }
        }}
      >
        {item.title}
      </div>
    )
  }

  render = ()  => {
    const item = this.props.item;
    if (!item) {
      return null;
    }
    if (item.admin && !this.props.user.admin) {
      return null;
    }
    if (item.page) {
      return this.renderMenuItem(item);
    }
    const level = this.props.level || 0;
    return (
      <div
        className={classnames({
          'sidebarSection': true,
          //'open': this.state.open,
          'open': true,
          [`level-${level}`]: true,
        })}
      >
        <div
          className='sectionHeader'
          onClick={e => {
            if (e.target === e.currentTarget) {
              this.setState({open: !this.state.open})
            }
          }}
        >{item.title}</div>
        <div className='sectionItems'>
          {item.items.map((child, index) =>
            <SidebarSection key={index} {...this.props} item={child} level={level+1}/>
          )}
        </div>
      </div>
    )
  }

}

export default connect(mapStoreToProps)(SidebarSection);
